import { render, staticRenderFns } from "./ConfirmMove.vue?vue&type=template&id=ce687914&scoped=true&"
import script from "./ConfirmMove.vue?vue&type=script&lang=ts&"
export * from "./ConfirmMove.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce687914",
  null
  
)

export default component.exports